import { TIME_ZONES } from './time_zones';

// Validate email format
export function isValidEmail(email) {
	let lowerEmail = email.toLowerCase();
	return (
		lowerEmail &&
		lowerEmail.length >= 5 &&
		lowerEmail.includes('@') &&
		lowerEmail.includes('.') &&
		// Disgusting regex to check for valid email format - https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
		// eslint-disable-next-line no-control-regex
		/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(lowerEmail)
	);
}

// Validate name format
export function isValidName(name) {
	return name && /\b([A-ZÀ-ÿ-,a-z. ']+[ ]*)+/.test(name);
}

// Validate time zone
export function isValidTimeZone(timeZone) {
	return timeZone && TIME_ZONES.includes(timeZone);
}

// Validate MFA code format
export function isValidMFACode(mfaCode) {
	return mfaCode && /^\d{6}$/.test(mfaCode);
}

// Validate MFA Backup code format
export function isValidMFABackupCode(mfaBackupCode) {
	return mfaBackupCode && /^[a-zA-Z0-9]{12}$/.test(mfaBackupCode);
}

// Validate password length
export function validPasswordLength(password) {
	return password && password.length >= 8 && password.length <= 32;
}

// Validate that password conatins at least one uppercase letter
export function validPasswordUppercase(password) {
	return password && /[A-Z]/.test(password);
}

// Validate that password contains at least one lowercase letter
export function validPasswordLowercase(password) {
	return password && /[a-z]/.test(password);
}

// Validate that password contains at least one number
export function validPasswordNumber(password) {
	return password && /[0-9]/.test(password);
}

// Validate that password contains at least one special character
export function validPasswordSpecial(password) {
	return password && /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|\\}~]/.test(password);
}

// Validate that password does not contain the email prefix
export function validPasswordNotEmail(password, email) {
	let lowerEmail = email.toLowerCase();
	let lowerPassword = password.toLowerCase();
	return password && !lowerPassword.includes(lowerEmail.split('@')[0]);
}